import { render } from "./testimonialFour.vue?vue&type=template&id=2e48a6f5"
import script from "./testimonialFour.vue?vue&type=script&lang=js"
export * from "./testimonialFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__